// Single source of truth mapping a step-function execution status to a semantic
// @decisiv/ui-components color (`success` | `danger` | `warning` | `information`).
// Consumed by the execution-status badges (ExecutionDetails/StatusTag) and by the
// Integration Health dashboard so its health bar and per-status counts always match
// the badges. Colours: green = succeeded / succeeded-no-results, red = failed,
// orange = completed-with-errors & circuit-breaker, blue = blocked-by-condition.
export const EXECUTION_STATUS_COLOR = {
  SUCCEEDED: 'success',
  NOT_FOUND: 'success',
  RUNNING: 'information',
  COMPLETED_WITH_ERRORS: 'warning',
  BLOCKED_BY_CIRCUIT_BREAKER: 'warning',
  RE_ENQUEUED_BY_CIRCUIT_BREAKER: 'warning',
  BLOCKED_BY_CONDITION_RULE: 'information',
  FAILED: 'danger',
};

// Unknown / one-off statuses (e.g. ExecutionDoesNotExist) read as an error.
export const DEFAULT_EXECUTION_STATUS_COLOR = 'danger';

export const executionStatusColor = (status) =>
  EXECUTION_STATUS_COLOR[status] || DEFAULT_EXECUTION_STATUS_COLOR;

export default executionStatusColor;
